import React, { useEffect } from "react";
import SidebarButton from "./SidebarButton";
import SidebarButtonAdmin from "./SidebarButtonAdmin";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FaTh, FaFolder, FaCog, FaUsers, FaChartBar, FaHome } from "react-icons/fa";
import { RootState } from "../../store";
import Footer from "../footer/Footer";

const SideBar = () => {
    const [userActive, setUserActive] = React.useState("");
    const [adminActive, setAdminActive] = React.useState("");
    const { profile } = useSelector((state: RootState) => state.account);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const adminButtons = [
        { text: "Dashboard", route: "/", icon: FaTh },
        { text: "Modules", route: "/ques-folders", icon: FaFolder },
        { text: "Control", route: "/admin-control", icon: FaCog },
        { text: "Leaderboard", route: "/participants", icon: FaUsers },
    ];

    const userButtons = [
        { text: "Home", route: "/", icon: FaHome },
        { text: "Progress", route: "/analytics", icon: FaChartBar },
        { text: "Leaderboard", route: "/participants", icon: FaUsers },
    ];

    const commonButtons: any[] = [];

    const isAdmin = profile?.role?.toUpperCase() === "ADMIN";
    const isCli = profile?.role?.toUpperCase() === "CLI";

    const cliButtons = [
        { text: "Leaderboard", route: "/participants", icon: FaUsers },
    ];

    const buttons = isAdmin
        ? adminButtons.concat(commonButtons)
        : isCli
            ? cliButtons.concat(commonButtons)
        : userButtons.concat(commonButtons);

    useEffect(() => {
        if (profile?.role) {
            const currentPath = location.pathname;
            const activeButton = buttons.find((btn) => btn.route === currentPath);
            if (activeButton) {
                isAdmin
                    ? setAdminActive(activeButton.text)
                    : setUserActive(activeButton.text);
            }
        }
    }, [location.pathname, buttons, profile?.role, isAdmin]);

    const handleNavigation = (route: string, name: string, action?: any) => {
        if (isAdmin) {
            setAdminActive(name);
        } else {
            setUserActive(name);
        }
        if (action) {
            dispatch(action());
        }
        navigate(route);
    };

    return (
        <div className="w-[250px] flex flex-col justify-start items-start p-3 bg-white border-r border-gray-200 overflow-y-auto shrink-0 transition-all duration-300 relative z-[200]">
            <div className="flex-1 w-full space-y-2">
                {buttons.map((btn) => {
                    const ButtonComponent = isAdmin ? SidebarButtonAdmin : SidebarButton;
                    const isActive = isAdmin ? adminActive === btn.text : userActive === btn.text;

                    return (
                        <div key={btn.text} className="w-full">
                            <ButtonComponent
                                buttonClass={`sidebar-item flex items-center w-full px-4 py-3 rounded-lg outline-none transition-all duration-200 cursor-pointer text-gray-600 ${isActive
                                    ? "bg-[#C5C4FE] text-gray-900 font-semibold"
                                    : "hover:bg-gray-100 hover:text-gray-900"
                                    }`}
                                buttonText={btn.text}
                                active={isActive}
                                setActive={() => handleNavigation(btn.route, btn.text, (btn as any).action)}
                                name={""}
                                icon={btn.icon}
                            />
                        </div>
                    );
                })}
            </div>

            <Footer />
        </div>
    );
};

export default SideBar;
